export const DEFAULT_MESSAGE_CREATED_CONDITION = [
  {
    attribute_key: 'message_type',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_CONVERSATION_CONDITION = [
  {
    attribute_key: 'browser_language',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_OTHER_CONDITION = [
  {
    attribute_key: 'status',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_ACTIONS = [
  {
    action_name: 'assign_agent',
    action_params: [],
  },
];

// Default conditions for Dotchat client-side automation events. They default
// to `is_present` so a freshly-created rule fires on EVERY event until the
// user narrows it down (no value required to save).
export const DEFAULT_REMINDER_CONDITION = [
  {
    attribute_key: 'title',
    filter_operator: 'is_present',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_KANBAN_CONDITION = [
  {
    attribute_key: 'board',
    filter_operator: 'is_present',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_CHATBOT_CONDITION = [
  {
    attribute_key: 'bot_name',
    filter_operator: 'is_present',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_CALENDAR_EVENT_CONDITION = [
  {
    attribute_key: 'title',
    filter_operator: 'is_present',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

// Timeout rules are threshold-driven: the duration condition defines how long
// since the last contact reply before the rule fires.
export const DEFAULT_TIMEOUT_CONDITION = [
  {
    attribute_key: 'minutes',
    filter_operator: 'is_greater_than',
    values: '60',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const MESSAGE_CONDITION_VALUES = [
  {
    id: 'incoming',
    name: 'Incoming',
    i18nKey: 'INCOMING',
  },
  {
    id: 'outgoing',
    name: 'Outgoing',
    i18nKey: 'OUTGOING',
  },
];

export const PRIORITY_CONDITION_VALUES = [
  {
    id: 'nil',
    name: 'None',
    i18nKey: 'NONE',
  },
  {
    id: 'low',
    name: 'Low',
    i18nKey: 'LOW',
  },
  {
    id: 'medium',
    name: 'Medium',
    i18nKey: 'MEDIUM',
  },
  {
    id: 'high',
    name: 'High',
    i18nKey: 'HIGH',
  },
  {
    id: 'urgent',
    name: 'Urgent',
    i18nKey: 'URGENT',
  },
];
